module.exports = __webpack_public_path__ + "static/media/yt-icon.d1938c58.svg";